import { ref, Ref } from 'vue'

import { IProduct } from '../../domain/IProduct'

import { getProductBySku } from '../../dependency-injection'

type ReactiveProductSku = Ref<string | undefined>
type ReactiveProduct = Ref<IProduct | undefined>

export function useProduct(sku: ReactiveProductSku) {
  const product: ReactiveProduct = ref(undefined)

  const loadProduct = async (): Promise<void> => {
    if (sku.value === undefined) {
      product.value = undefined
      return
    }

    product.value = await getProductBySku.execute(sku.value)
  }

  return { product, loadProduct }
}
